import { Paragraph } from "../atoms";
import { Flex } from "../cores";
import { IconStarNeg } from "../icons";

interface IIconPumpScore {
  green?: boolean;
  value: string;
  small?: boolean;
  noColor?: boolean;
  effAnm?: string;
}
const IconPumpScore = ({ green, value, small, noColor }: IIconPumpScore) => {
  return (
    <Flex
      sx={{
        width: small ? "2.375rem" : "65px",
        paddingX: "xs",
        paddingY: "3xs",
        borderRadius: "5px",
        textAlign: "center",
        justifyContent: "center",
        boxShadow: noColor
          ? "none"
          : "0px 2px 5px -1px rgb(50 50 93 / 25%), 0px 1px 3px -1px rgb(0 0 0 / 30%)",
        backgroundColor: noColor
          ? "inherit"
          : green
          ? "secondaryScale.6"
          : "quanternaryScale.3",
        color: noColor
          ? "black"
          : green
          ? "secondaryScale.1"
          : "quanternaryScale.9",
        fontWeight: noColor ? "normal" : "bold",
      }}
    >
      <Paragraph sx={{ fontSize: "2xs" }}>{value}</Paragraph>
    </Flex>
  );
};

export default IconPumpScore;
